<template>
  <div class="site-section" id="mint">
    <div id="mint-container-outer">
      <h1 class="is-size-1 font-headline text-center">
        <span>- FRENS -</span>
      </h1>
      <div class="columns mint-area">
        <div class="mint-area" style="margin: 0 auto; width: 100%; height: 88vh;">
          <button v-if="!signed_in" class="btn-mint" v-on:click="signIn()">
            <span>CONNECT WALLET</span>
          </button>

          <div v-if="signed_in" style="width: 100%; height: 100%;">
            <div v-if="wrongNetwork">
              <p class="mt-3">Please connect to the correct network.</p>
            </div>
            <div v-else style="width: 100%; height: 100%;">

              <button v-if="signed_in" class="btn-mint active" >
                <span>WALLET CONNECTED</span>
              </button>
              <!-- =========================== START =========================== -->

              <div v-if="tokensOfOwner.length > 0 && tokensOfOwner[0] != ''" style="width: 100%; height: 100%;">
                <!-- <div>{{ tokensOfOwner }}</div> -->
                <iframe allowfullscreen="allowfullscreen" scrolling="no" class="fp-iframe" src="https://heyzine.com/flip-book/999b7d87cd.html" style="border: 1px solid lightgray; width: 100%; height: 100%;"></iframe>
              </div>
              <div v-else>
                Please <a href="http://mint.abugtravelsfar.com" target="_blank" style="color: #fff;">mint</a> a token to access this content!
              </div>

              <!-- =========================== END =========================== -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<!-- ============================================================================ -->

<script>
import Web3 from "web3";
import { ADDRESS, ABI } from "../../config.js";
export default {
  name: "Mint",
  data() {
    return {
      signed_in: false,
      is_minting: false,
      wallet_address: null,
      how_many_tokens: 1,
      contract: null,
      contract_address: null,
      total_supply: 0,
      sale_started: true,
      token_price: 35000000000000000,
      transaction_hash: null,
      minted: false,
      last_receipt: null,
      has_failed: false,
      wrongNetwork: false,
      error_message: "",
      user_error: false,
      user_error_message: "",
      whitelisterror: false,
      loading: true,
      totalMinted: 0,
      totalPurchased: 0,
      totalReserved: 0,
      maxTokens: 0,
      tokensOfOwner: null
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      this.callContractData();
    });
  },
  methods: {
    reset() {
      this.has_failed = false;
    },
    async signIn() {
      if (this.signed_in) {
        return;
      }

      this.loading = true;
      this.whitelisterror = false;

      if (typeof window.web3 !== "undefined") {
        // Use existing gateway
        window.web3 = new Web3(window.ethereum);
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "No Ethereum interface injected into browser. Read-only access"
        );
      }

      if (window.ethereum) {
        let self = this;
        try {
          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          window.web3.eth.net.getNetworkType().then((network) => {
            if (network != process.env.VUE_APP_ETHNETWORK) {
              self.wrongNetwork = true;
            }
          });

          let wallet = accounts[0];

          // if(self.isPreSale()) {
          self.signed_in = true;
          self.wallet_address = wallet;

          self.loading = false;
          self.callContractData();
        } catch (error) {
          if (error.code === 4001) {
            // User rejected request
          }

          // eslint-disable-next-line no-console
          console.log(error);
        }
      }
    },
    async callContractData() {
      if (typeof window.web3 !== "undefined") {
        // Use existing gateway
        window.web3 = new Web3(window.ethereum);
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "No Ethereum interface injected into browser. Read-only access"
        );
      }

      this.contract = new window.web3.eth.Contract(ABI, ADDRESS);
      // this.total_supplies = await this.contract.methods.totalSupply().call();
      this.token_price = 35000000000000000;
      this.totalPurchased = await this.contract.methods.totalMinted(0).call();
      this.totalReserved = await this.contract.methods.totalReserved(0).call();
      this.maxTokens = await this.contract.methods.maxTokens(0).call();
      let _tokens = await this.contract.methods.tokensOfOwner(this.wallet_address).call();
      // this.token_price = await this.contract.methods.prices(0).call();
      if(this.wallet_address) {
        this.tokensOfOwner = _tokens.toString().split(",")
      }

      this.totalMinted = Number(this.totalPurchased) + Number(this.totalReserved);
    },
  },
};
</script>

<!-- ============================================================================ -->

<style scoped>
.site-section {
  font-family: "Fredoka One", "Trebuchet MS", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h1 {
  /* background: #000; */
  color: #fff;
}
  h1 span {
    /* border-bottom: 1px solid #fff; */
    padding-bottom: 10px;
  }

.mint {
  /* background: rgba(255, 255, 255, 0.2); */
  /* max-width: 540px !important; */
  margin: 0 auto;
  /* padding-bottom: 20px; */
  padding: 10px 20px;
}

  .input-box {
    background: #000;
  }

  .mint-container-outer {
    position: relative;
    background: #000;
    /* background: url(../assets/mint-background.jpg) -74px 0 repeat; */
    /* background-size: 1110px; */
  }

  .price {
    font-size: 20px;
  }
    .price p {
      margin-bottom: 0 !important;
      padding-bottom: 5px !important;
    }

  .btn-mint {
    font-family: "Fredoka One", "Trebuchet MS", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 24px;
    background: transparent;
    border: none;
    max-width: 200px;
    cursor: pointer;
    margin: 0 auto;
    color: #fff;
    padding: 10px 20px;
  }
    .btn-mint:hover {
      background: rgba(255, 255, 255, 0.3);
    }
    .btn-mint-final {
      /* max-width: 170px !important; */
      /* background: #000; */
      /* padding: 10px 0 0 0; */
      color: #fff;
      font-size: 16px;
      width: 100%;
      background: #E3558D;
      margin: 10px 0 0 0;
      padding: 0;
    }
    .btn-mint.active {
      display: block;
      position: absolute;
      top: -145px;
      right: 10px;
      opacity: 0.4;
    }
    .btn-mint.active:hover {
      border: none;
      cursor: default;
    }
  .btn-mint .container .label {
    font-size: 36px;
    padding: 10px 20px 0 20px;
  }
  .btn-mint.active .container .label {
    font-size: 12px;
    padding: 10px 20px;
    color: #fff;
  }
  .btn-mint {
    max-width: 100%;
  }
  .btn-mint .container .label.connect {
    font-size: 24px;
    padding: 10px 20px;
    color: #fff;
  }
  .btn-mint-final span {
    font-size: 38px;
    color: #fff;
  }

  #mint {
    padding-bottom: 10px;
  }

  #mint-container {
    /* background: #000; */
    color: #fff;
  }

  .mint p {
    padding-top: 0;
    padding-bottom: 0;
  }

  .mint-inputs {
    /* background: #000; */
  }

  .mint-inputs .how-many {
    padding: 0 10px;
  }

  input.number-of-mints {
    width: 70px;
    margin: 0 0 0 10px;
  }

  .progress {
    width: 80%;
    margin: 0 auto;
  }

  .notification {
    background: transparent;
    padding: 20px !important;
  }
  .notification.is-warning {
    margin-top: 0;
    background: #fcc;
    color: #333;
  }
  .notification.is-link {
    padding-top: 0.75rem;
    color: #fff;
  }
  .notification.is-success {
    margin-bottom: 0;
  }
  div.view-on-opensea {
    padding-bottom: 20px;
  }
    div.view-on-opensea a {
      color: #fff;
    }
</style>

<!-- ============================================================================ -->

<style>
body {
  background: #000;
  color: #fff;
}

  .mint-area {
    text-align: center;
    padding-top: 5px;
  }

    .mint-area .column {
      margin: 5px;
      background: #333;
    }

    .book-number {
      font-size: 16px;
    }

.eth {
  font-family: helvetica, arial, sans-serif !important;
}
</style>

<!-- ============================================================================ -->

<style>
@media (max-width: 550px) {}
</style>